<div *ngIf="container === 'back'; else elseBlock">
    <galec-back-container class="backend"></galec-back-container>
</div>
<ng-template #elseBlock>
    <router-outlet></router-outlet>
</ng-template>
